import React from 'react'

const MaidServices = () => {
  return (
    <div className="container py-4">
    <p>These services can be tailored to fit your specific needs. Services include, but are not limited to:</p>

  <h2>Maid Services:</h2>
  <ol>
    <li>Laundry Services: Washing, folding, and organizing clothes.</li>
    <li>Organizing: Tidying up rooms, closets, and general areas.</li>
    <li>Changing Bed Linens: Changing sheets and making beds with fresh linens.</li>
    <li>Dishwashing: Washing dishes and putting them away.</li>
    <li>Pet Care: Feeding or walking pets (if applicable).</li>
    <li>Plant Care: Watering plants or treating them (if applicable).</li>
  </ol>

  <h2>Housekeeping Services:</h2>
  <ol>
    <li>Lightbulb replacement: Changing out light bulbs.</li>
    <li>Battery replacement: Changing out batteries for smoke detectors, carbon monoxide alarms, etc.</li>
    <li>Pests: Setting up, checking/emptying, resetting mousetraps.</li>
    <li>Leaf Blowing Decks and Walkways: Keeping walkways clear of leaf/yard debris.</li>
    <li>Seasonal Decoration: Seasonal decoration set up and take down.</li>
    <li>Disposal of Unwanted Items: Hauling away unwanted items, either for donation or for the landfill/incinerator.</li>
  </ol>
    </div>

)
}

export default MaidServices